export enum PFlagSize {
  LARGE = 'large',
  SMALL = 'small',
  SMALLEST = 'smallest',
}
